/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Page_Meta_DescriptionInputs */

const en_landing_page_meta_description = /** @type {(inputs: Landing_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider helps you build long-term wealth with diversified portfolios, clear guidance, and disciplined management.`)
};

const de_landing_page_meta_description = /** @type {(inputs: Landing_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider hilft Ihnen, mit diversifizierten Portfolios, klarer Anleitung und diszipliniertem Management langfristig Vermögen aufzubauen.`)
};

const pt_br2_landing_page_meta_description = /** @type {(inputs: Landing_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Glider ajuda você a construir patrimônio no longo prazo com portfólios diversificados, orientação clara e gestão disciplinada.`)
};

const tr_landing_page_meta_description = /** @type {(inputs: Landing_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider, çeşitlendirilmiş portföyler, anlaşılır rehberlik ve disiplinli yönetimle uzun vadeli servet oluşturmanıza yardımcı olur.`)
};

const zh_cn2_landing_page_meta_description = /** @type {(inputs: Landing_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider 通过多元化投资组合、清晰指导和有纪律的管理，帮助你构建长期财富。`)
};

const zh_hk2_landing_page_meta_description = /** @type {(inputs: Landing_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider 透過多元化投資組合、清晰指導和有紀律的管理，協助你建立長期財富。`)
};

const ko_kr2_landing_page_meta_description = /** @type {(inputs: Landing_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider는 분산 포트폴리오, 명확한 안내와 규율 있는 관리로 장기적인 자산 형성을 돕습니다.`)
};

const ru_ru2_landing_page_meta_description = /** @type {(inputs: Landing_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider помогает создавать долгосрочное благосостояние с помощью диверсифицированных портфелей, понятных рекомендаций и дисциплинированного управления.`)
};

const es_419_landing_page_meta_description = /** @type {(inputs: Landing_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider te ayuda a construir patrimonio a largo plazo con portafolios diversificados, orientación clara y gestión disciplinada.`)
};

/**
* | output |
* | --- |
* | "Glider helps you build long-term wealth with diversified portfolios, clear guidance, and disciplined management." |
*
* @param {Landing_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const landing_page_meta_description = /** @type {((inputs?: Landing_Page_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Page_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_page_meta_description(inputs)
	if (locale === "de") return de_landing_page_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_landing_page_meta_description(inputs)
	if (locale === "tr") return tr_landing_page_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_landing_page_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_landing_page_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_landing_page_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_landing_page_meta_description(inputs)
	return es_419_landing_page_meta_description(inputs)
});